import React, { ReactNode } from "react";
import { StyledInfoContainer } from "./InfoContainer.styled";

export const InfoContainer = ({
  variant,
  children,
}: {
  variant: string;
  children: ReactNode;
}) => {
  return (
    <StyledInfoContainer $variant={variant}>{children}</StyledInfoContainer>
  );
};
